module.exports = __webpack_public_path__ + "6f8f7b42180d2557ee22d106065b539a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/formFactors/covert.png
// module id = 1641
// module chunks = 5